import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAdminAccess from '../hooks/useAdminAccess';
export default function AdminLink() {
  const { allowed } = useAdminAccess();
  const { t } = useTranslation();
  return allowed ? <Link className="inline-flex rounded-xl bg-slate-950 px-4 py-3 font-bold text-white" to="/admin">{t('administration.title')}</Link> : null;
}
